import { render, staticRenderFns } from "./SiteNew.vue?vue&type=template&id=1c827ab8"
import script from "./SiteNew.vue?vue&type=script&lang=js"
export * from "./SiteNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports